import React from 'react';
import {
  Button,
  Icon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Wrap,
  WrapItem,
  useColorModeValue,
} from '@chakra-ui/core';
import { BiChevronDown } from 'react-icons/bi';
import { User } from '../types';

const VOTE_VALUES = [1, 2, 3, 5, 8, 13];

interface VotingButtonsProps {
  user: User | undefined;
  modsExist: boolean;
  isDisabled: boolean;
  onVote: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onChangeName: () => void;
  onCopyInvite: () => void;
  onStartModeration: () => void;
  onExitRoom: () => void;
}

const VotingButtons = ({
  user,
  modsExist,
  isDisabled,
  onVote,
  onChangeName,
  onCopyInvite,
  onStartModeration,
  onExitRoom,
}: VotingButtonsProps) => {
  const isVotingDisabled =
    isDisabled || (user?.metadata.mod.enabled && !user?.metadata.mod.allowVote);
  const menuBg = useColorModeValue('white', 'gray.800');
  const menuBorder = useColorModeValue('gray.200', 'gray.600');

  return (
    <Wrap my={5} spacing={3} align="center">
      {VOTE_VALUES.map(score => (
        <WrapItem key={score}>
          <Button
            variant={
              String(user?.metadata.vote) === String(score)
                ? 'solid'
                : 'outline'
            }
            colorScheme="purple"
            h={16}
            w={12}
            fontSize="2xl"
            fontWeight="bold"
            borderRadius="xl"
            value={score}
            onClick={onVote}
            isDisabled={isVotingDisabled}>
            {score}
          </Button>
        </WrapItem>
      ))}
      <WrapItem>
        <Menu>
          <MenuButton
            as={Button}
            isDisabled={isDisabled}
            variant="ghost"
            colorScheme="gray"
            rightIcon={<Icon as={BiChevronDown} />}>
            Actions
          </MenuButton>
          <MenuList bg={menuBg} borderColor={menuBorder}>
            <MenuItem onClick={onChangeName}>Change name</MenuItem>
            <MenuItem onClick={onCopyInvite}>Copy invite link</MenuItem>
            {/* Issue #9: this is a race-prone UI guard, not server enforcement. */}
            {!modsExist ? (
              <MenuItem onClick={onStartModeration}>Start Moderation</MenuItem>
            ) : null}
            <MenuItem onClick={onExitRoom}>Exit room</MenuItem>
          </MenuList>
        </Menu>
      </WrapItem>
    </Wrap>
  );
};

export default VotingButtons;
